import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSync,
  faExclamationTriangle,
} from "@fortawesome/free-solid-svg-icons";
import { redColor } from "../../../UI/DMCharts";
import SkeletonLoader from "../../../UI/SkeletonLoader";

const ChartCard = ({
  title,
  loading,
  error,
  onRetry,
  onClick,
  children,
  style = {},
}) => {
  // Check if chart data is null (still loading) by examining children props
  const isChartDataLoading = React.Children.toArray(children).some(
    (child) => child.props && child.props.data === null
  );

  if (loading || isChartDataLoading) {
    return (
      <div
        style={{
          cursor: onClick ? "pointer" : "default",
          ...style,
        }}
        onClick={onClick}
      >
        <SkeletonLoader type="chart" height="350px" />
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          cursor: onClick ? "pointer" : "default",
          background: "#fff3f3",
          border: `1px solid ${redColor}`,
          borderRadius: "8px",
          padding: "15px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "300px",
          ...style,
        }}
        onClick={onClick}
      >
        <FontAwesomeIcon
          icon={faExclamationTriangle}
          style={{
            color: redColor,
            fontSize: "32px",
            marginBottom: "15px",
          }}
        />
        <h3 style={{ color: redColor, marginBottom: "10px" }}>{title}</h3>
        <div
          style={{ color: redColor, marginBottom: "15px", textAlign: "center" }}
        >
          Error: {typeof error === "string" ? error : "Failed to load chart"}
        </div>
        {onRetry && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              onRetry();
            }}
            style={{
              background: redColor,
              color: "white",
              border: "none",
              padding: "8px 16px",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            <FontAwesomeIcon icon={faSync} style={{ marginRight: "8px" }} />
            Retry
          </button>
        )}
      </div>
    );
  }

  return (
    <div
      style={{
        cursor: onClick ? "pointer" : "default",
        background: "white",
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        padding: "15px",
        ...style,
      }}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default ChartCard;
